import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import useSave from "../../../Hooks/useSave";
// import BasicTable from "../../../components/InfoDisplay/InfoDisplay";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import CompanyInfo from "./CompanyInfo";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MUIDataTable from "mui-datatables";
import { Autocomplete } from "@mui/material";
import InputMask from "react-input-mask";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { createFilterOptions } from "@mui/material/Autocomplete";

function AddCustomer() {
  const { customerId } = useParams();
  const { fetchGraphql, DialogSave } = useSave();
  const navigate = useNavigate();

  const [inputValue, setInputValue] = useState();
  const [customer, setCustomer] = useState({});
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    //   fetchGraphql({
    //     query: `query Customer($customerId: ID!) {
    //       customer(customerId: $customerId) {
    //         customerId
    //         customerName
    //         customerPhoneNumber
    //         customerAltPhoneNumber
    //         customerEmail
    //         customerNote
    //         customerBillingEmails
    //         customerIsGroup
    //         customerBillingAddress {
    //           addressId
    //           addressLine
    //           addressLine2
    //           city
    //           state
    //           zip
    //           comments
    //         }
    //         customerShippingAddress {
    //           addressId
    //           addressLine
    //           addressLine2
    //           city
    //           state
    //           zip
    //           comments
    //         }
    //         customerGroupCode
    //         customerType
    //       }
    //     }`,
    //     variables: { customerId },
    //   }).then((result) => {
    //     setCustomer(result.data.customer);
    setIsLoading(false);
    //   });
  }, []);

  useEffect(() => {
    fetchGraphql({
      query: `query Products {
        customers {
          customerName
          customerId
          customerPhoneNumber
          customerEmail
        }
      }`,
    }).then((result) => {
      setCustomers(result.data.customers);
    });
  }, []);

  function handleCreateOrder() {
    //create date
    const today1 = new Date();
    const tomorow1 = new Date(today1.getTime() + 24 * 60 * 60 * 1000);
    const tomorowNoTime = new Date(new Date(tomorow1).setHours(0, 0, 0, 0));

    //create customer
    fetchGraphql({
      query: `mutation CreateCustomer($customer: customerInput) {createCustomer(customer: $customer)}`,
      variables: { customer },
    }).then((result) => {
      console.log(result);

      //create order for customer
      fetchGraphql({
        query: `mutation CreateOrder($order: orderInput) {
          createOrder(order: $order)
        }`,
        variables: {
          order: {
            customerId: result.data.createCustomer,
            deliveryDate: tomorowNoTime,
            orderedVia: "Front Desk",
            orderStatus: "Draft",
          },
        },
      }).then((result) => {
        //navigate to order
        navigate(`/orders/new-order-customer/${result.data.createOrder}`);
      });
    });
  }

  const customersOptions = customers?.map((item) => ({
    ...item,
    label: item.customerPhoneNumber,
  }));

  return (
    <Box
      sx={{
        // height: "100%",
        display: "flex",
        flexDirection: "row",
        width: "100%",
      }}
    >
      <DialogSave />

      <Paper
        sx={{
          width: "100%",
          // marginLeft: "20px",
          padding: "20px",
          overflow: "auto",
        }}
      >
        <Typography sx={{ margin: "20px" }}>Customer Info</Typography>

        <Divider sx={{ marginBottom: "20px" }} />

        <Box sx={{ display: "flex" }}>
          <TextField
            sx={{ margin: "10px" }}
            value={customer.customerName || ""}
            onChange={(e) => {
              setCustomer({
                ...customer,
                customerName: e.target.value,
              });
            }}
            label="Name"
            color="primary"
          />

          <Autocomplete
            disablePortal
            onChange={(event, value) => {
              if (value.customerId) {
                fetchGraphql({
                  query: `query Customer($customerId: ID!) {
                      customer(customerId: $customerId) {
                        customerId
                        customerName
                        customerPhoneNumber
                        customerAltPhoneNumber
                        customerEmail
                        customerNote
                        customerBillingEmails
                        customerIsGroup
                        customerBillingAddress {
                          addressId
                          addressLine
                          addressLine2
                          city
                          state
                          zip
                          comments
                        }
                        customerShippingAddress {
                          addressId
                          addressLine
                          addressLine2
                          city
                          state
                          zip
                          comments
                        }
                        customerGroupCode
                        customerType
                      }
                    }`,
                  variables: { customerId: value.customerId },
                }).then((result) => {
                  setCustomer(result.data.customer);
                });
              }
            }}
            value={customer.customerPhoneNumber || ""}
            autoSelect={true}
            autoHighlight={true}
            options={customersOptions}
            filterOptions={(options, state) => {
              const mask = (e) => {
                var x = state.inputValue
                  .replace(/\D/g, "")
                  .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

                if (!x[2]) {
                  return x[1];
                } else {
                  return "(" + x[1] + ") " + x[2] + (x[3] ? " - " + x[3] : "");
                }
              };

              return (
                options.filter((item) => item?.label?.includes(mask())) ||
                options
              );
            }}
            getOptionLabel={(option) => option.label ?? option}
            sx={{ minWidth: "250px", margin: "10px" }}
            renderInput={(params) => {
              return <TextField {...params} label="Phone Number" />;
            }}
          />

          <TextField
            sx={{ margin: "10px" }}
            key="2"
            value={customer.customerBillingEmails || ""}
            onChange={(e) =>
              setCustomer({
                ...customer,
                customerBillingEmails: e.target.value,
              })
            }
            label="Email"
            // placeholder="add coma between emails"
            color="primary"
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            marginTop: "20px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Typography sx={{ margin: "20px" }}>Address</Typography>

            <Divider sx={{ marginBottom: "20px" }} />

            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <TextField
                sx={{ margin: "10px", width: "490px" }}
                value={customer.customerBillingAddress?.addressLine || ""}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerBillingAddress: {
                      ...customer.customerBillingAddress,
                      addressLine: e.target.value,
                    },
                  })
                }
                label="Name"
                variant="outlined"
              />

              <TextField
                sx={{ margin: "10px", width: "490px" }}
                value={customer.customerBillingAddress?.addressLine2 || ""}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerBillingAddress: {
                      ...customer.customerBillingAddress,
                      addressLine2: e.target.value,
                    },
                  })
                }
                label="Address"
                variant="outlined"
              />

              <Box>
                <TextField
                  sx={{ margin: "10px", width: "150px" }}
                  value={customer.customerBillingAddress?.city || ""}
                  onChange={(e) =>
                    setCustomer({
                      ...customer,
                      customerBillingAddress: {
                        ...customer.customerBillingAddress,
                        city: e.target.value,
                      },
                    })
                  }
                  label="City"
                  color="primary"
                />

                <TextField
                  sx={{ margin: "10px", width: "150px" }}
                  value={customer.customerBillingAddress?.state || ""}
                  required={true}
                  onChange={(e) =>
                    setCustomer({
                      ...customer,
                      customerBillingAddress: {
                        ...customer.customerBillingAddress,
                        state: e.target.value,
                      },
                    })
                  }
                  label="State"
                  color="primary"
                />

                <TextField
                  sx={{ margin: "10px", width: "150px" }}
                  value={customer.customerBillingAddress?.zip || ""}
                  onChange={(e) =>
                    setCustomer({
                      ...customer,
                      customerBillingAddress: {
                        ...customer.customerBillingAddress,
                        zip: e.target.value,
                      },
                    })
                  }
                  label="Zip"
                  color="primary"
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Typography sx={{ margin: "20px" }}>Customer Notes</Typography>

        <Divider sx={{ marginBottom: "20px", marginTop: "10px" }} />

        <TextField
          sx={{ margin: "10px", width: "500px" }}
          multiline
          onChange={(e) =>
            setCustomer({
              ...customer,
              customerNote: e.target.value,
            })
          }
          label="Notes"
          value={customer.customerNote || ""}
          color="primary"
        />

        <Divider sx={{ marginBottom: "20px", marginTop: "10px" }} />

        <Button
          variant="contained"
          sx={{
            width: "fit-content",
            marginLeft: "10px",
          }}
          onClick={handleCreateOrder}
        >
          Create Order
        </Button>
      </Paper>
    </Box>
  );
}

export default AddCustomer;
